import { Link } from 'react-router-dom';
import Button from './Button.tsx';

interface QuestionnaireSuccessProps {
  onClose: () => void;
}

const QuestionnaireSuccess: React.FC<QuestionnaireSuccessProps> = ({ onClose }) => {
  return (
    <div className="vertical-scroll pb-4">
      <div className="bg-secondary-color pt-5 ps-4 pe-4 pb-4 fz-29">
        <h2>Hvala što koristiš Yettel Shopping</h2>
      </div>
      <div className="bg-divider-yettel" />
      <div className="ps-4 pe-4 pb-4 pt-4">
        <p>
          Ukoliko želiš da proširiš svoju listu interesovanja, to možeš da uradiš u sekciji{' '}
          <Link to="/profil/interesovanja" className="text-decoration-underline" onClick={() => onClose()}>
            Podešavanja/Moja interesovanja
          </Link>
        </p>
        <p className="font-yettel-bold mt-3">Uživaj u svojim omiljenim ponudama.</p>
      </div>
      <div className="mt-4">
        <Button onClick={onClose}>OK</Button>
      </div>
    </div>
  );
};

export default QuestionnaireSuccess;
